<template>
  <div class="user-form">

    <b-modal :active.sync="showAddOtherDetailModal">
      <div class="box" style="">
        <h1 class="title is-5">Add Other Detail</h1>
        <b-field label="Name">
          <b-input placeholder="detail name" v-model="otherDetailKey"></b-input>
        </b-field>
        <button class="button is-info" @click="addNewDetail">Add Detail</button>
      </div>
    </b-modal>

    <form autocomplete="off">
      <input autocomplete="off" name="hidden" type="text" style="display:none;">
      <input autocomplete="off" name="hidden" type="password" style="display:none;">

      <div class="columns">
        <div class="column">
          <div class="box">

            <!-- NAME -->
            <b-field label="Firts Name">
              <b-input placeholder="first name" v-model="user.firstName"></b-input>
            </b-field>
            <b-field label="Last Name">
              <b-input placeholder="last name" v-model="user.lastName"></b-input>
            </b-field>

            <!-- LOGIN -->
            <br />
            <b-field label="Username">
              <b-input autocomplete="off" placeholder="username" v-model="user.username"></b-input>
            </b-field>
            <br />
            <button v-if="!newUser" class="button" @click.prevent="changingPassword = !changingPassword">
              <span v-if="changingPassword">Cancel</span>&nbsp;Change Password
            </button>
            <template v-if="changingPassword">
              <b-field label="Password" :message="passwordMsg">
                <b-input autocomplete="off" type="password" placeholder="password" v-model="user.password"></b-input>
              </b-field>
              <b-field label="Confirm Password" :type="confirmPassword !== user.password ? 'is-danger' : ''">
                <b-input autocomplete="off" type="password" placeholder="confirm password" v-model="confirmPassword"></b-input>
              </b-field>
            </template>
          </div>
        </div>

        <div class="column">
          <div class="box">

            <!-- INFO -->
            <b-field label="Phone">
              <b-input type="number" pattern="[0-9]*" placeholder="phone" v-model="user.phone"></b-input>
            </b-field>
            <b-field label="Address">
              <b-input type="textarea" placeholder="address" v-model="user.address"></b-input>
            </b-field>
          </div>

          <div class="box">
            <!-- OVERTIME PAID -->
            <b-field label="Overtime Paid up to">
              <b-datepicker
                v-model="overtimePaidDate"
                icon-pack="fas"
                :mobile-native="false"
                placeholder="not set"
                icon="calendar-check">
                <div class="has-text-right">
                  <button class="button is-small" @click.prevent="overtimePaidDate = null">Clear</button>
                  <button class="button is-primary is-small" @click.prevent="overtimePaidDate = new Date()">Today</button>
                </div>
              </b-datepicker>
            </b-field>
            <!-- DEFAULT HOURS -->
            <b-field label="Default Start Time">
              <time-input v-model="defaultStartTime" />
            </b-field>
            <b-field label="Default End Time">
              <time-input v-model="defaultEndTime" />
            </b-field>
          </div>

        </div>
      </div>

      <!-- EMERGENCY CONTACTS -->
      <div class="columns">
        <div class="column">
          <div class="box">
            <label class="label hoverable" @click="user.emergencyContacts.push({ name:'', phone:'' })">
              Emergency Contacts <i class="fas fa-plus is-success"></i>
            </label>

            <div v-for="(contact, index) in user.emergencyContacts" :key="index">
              <hr />
              <div class="columns">
                <div class="column no-padding-left">
                  <b-field label="Name">
                    <b-input placeholder="name" v-model="contact.name"></b-input>
                  </b-field>
                </div>
                <div class="column no-padding-right">
                  <div class="flex">
                    <div class="flex-1">
                      <b-field label="Phone">
                        <b-input placeholder="phone" v-model="contact.phone"></b-input>
                      </b-field>
                    </div>
                    <div style="padding-left: 10px">
                      <label for="" class="label">&nbsp;</label>
                      <button class="button is-danger" @click.prevent="user.emergencyContacts.splice(index, 1)">
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- OTHER DETAILS -->
       <div class="columns">
        <div class="column">
          <div class="box">
            <label class="label hoverable" @click="showAddOtherDetailModal = true">
              Other Details <i class="fas fa-plus is-success"></i>
            </label>

            <div v-for="(detail, index) in user.otherDetails" :key="index">
              <hr />
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">{{ detail.key }}</label>
                </div>
                <div class="field-body">
                  <div class="field is-grouped">
                    <p class="control is-expanded">
                      <input class="input" type="text" v-model="detail.value">
                    </p>
                    <p class="control">
                      <button class="button is-danger" @click.prevent="user.otherDetails.splice(index, 1)">
                        <i class="fas fa-times"></i>
                      </button>
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- ALERTS -->
      <div class="columns">
        <div class="column">
          <div class="box">
            <label class="label">Alerts</label>
            <div class="columns is-multiline">
              <div class="column is-2" v-for="alert of alerts" :key="alert">
                <div class="field" >
                    <b-checkbox v-model="user[alert]">
                      {{ alert | unCamel }}
                    </b-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- MISC -->
      <div class="columns">
        <div class="column">
          <div class="box">
            <label class="label">MISC</label>
            <div class="columns is-multiline">
              <div class="column is-2">
                <div class="field" >
                    <b-checkbox v-model="user.includeInRegister">
                      Include In Register
                    </b-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- PRIVILEGES -->
      <div class="columns">
        <div class="column">
          <div class="box">
            <b-field label="Privileges"></b-field>
            <div class="columns is-multiline">
              <div class="column is-2" v-for="priv of privileges" :key="priv.name">
                <div class="field" >
                    <b-checkbox v-model="priv.checked">
                      {{ priv.name }}
                    </b-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div v-if="msg.length" class="notification">{{ msg }}</div>
          <div v-if="infoMsg.length" class="notification is-info">{{ infoMsg }}</div>
          <div  v-if="errMsg.length" class="notification is-danger">{{ errMsg }}</div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="buttons flex">
            <div class="flex-1">
              <button :disabled="loading" class="button is-info" :class="{'is-loading': loading === 'submitting'}" @click.prevent="submitUser">submit</button>
              <button :disabled="loading" v-if="showCancel" class="button" @click="$emit('cancel')">cancel</button>
            </div>
            <div>
              <button :disabled="loading" class="button is-danger" :class="{'is-loading': loading === 'disabling'}" @click="disableUser()">Disable User</button>
            </div>
          </div>
        </div>
      </div>

    </form>
  </div>
</template>

<style>
  .user-form .no-padding-left {
    padding-left: 0;
  }

  .user-form .no-padding-right {
    padding-right: 0;
  }

  @media (max-width: 768px) {
    .user-form .no-padding-left {
        padding-left: 0;
        padding-right: 0;
      }

      .user-form .no-padding-right {
        padding-left: 0;
        padding-right: 0;
      }
  }
</style>

<script>
import TimeInput from './TimeInput'
export default {
  name: 'UserForm',
  components: {
    TimeInput
  },
  props: {
    user: {
      default () {
        return {
          firstName: '',
          lastName: '',
          username: '',
          password: '',
          phone: '',
          address: '',
          privileges: [],
          includeInRegister: true,
          defaultStartTime: '7:00 am',
          defaultEndTime: '3:30 pm',
          emergencyContacts: [],
          otherDetails: [],
          active: true
        }
      }
    },
    newUser: { default: false },
    passwordMsg: { default: '' },
    showCancel: { default: false },
    loading: { default: false },
    msg: { default: '' },
    infoMsg: { default: '' },
    errMsg: { default: '' }
  },
  data () {
    return {
      changingPassword: false,
      confirmPassword: '',
      overtimePaidDate: null,
      defaultStartTime: '7:00 am',
      defaultEndTime: '3:30 pm',
      privileges: [],
      otherDetailKey: '',
      showAddOtherDetailModal: false
    }
  },
  computed: {
    alerts () { return this.$store.getters.settings.alerts }
  },
  mounted () {
    if (this.user.defaultStartTime) {
      this.defaultStartTime = this.user.defaultStartTime
    }
    if (this.user.defaultEndTime) {
      this.defaultEndTime = this.user.defaultEndTime
    }
    if (this.user.overtimePaid) {
      this.overtimePaidDate = this.$moment.unix(this.user.overtimePaid).toDate()
    }
    if (!this.user.otherDetails) {
      this.$set(this.user, 'otherDetails', [])
    }
    if (!this.user.emergencyContacts) {
      this.$set(this.user, 'emergencyContacts', [])
    }

    for (let alert in this.alerts) {
      if (typeof this.user[alert] !== 'boolean') {
        this.$set(this.user, alert, false)
      }
    }

    this.changingPassword = this.newUser
    this.$firestore.collection('privileges').get().then(snapShot => {
      snapShot.forEach(doc => {
        let data = doc.data()
        this.privileges.push({
          name: data.name,
          checked: this.user.privileges && this.user.privileges.indexOf(data.name) >= 0
        })
      })
    })
  },
  methods: {
    addNewDetail (detail) {
      this.otherDetailKey = this.otherDetailKey.trim()
      if (this.otherDetailKey.length) {
        this.user.otherDetails.push({ key: this.otherDetailKey, value: '' })
        this.otherDetailKey = ''
      }
      this.showAddOtherDetailModal = false
    },
    submitUser () {
      if (!this.changingPassword) {
        this.user.password = ''
      }
      if (this.user.password && this.user.password !== this.confirmPassword) {
        console.log('passwords dont match')
        return
      }
      this.user.defaultStartTime = this.defaultStartTime
      this.user.defaultEndTime = this.defaultEndTime
      if (this.overtimePaidDate) {
        this.user.overtimePaid = this.$moment(this.overtimePaidDate).endOf('day').unix()
      } else {
        this.user.overtimePaid = 0
      }
      let privs = []
      this.privileges.forEach(priv => {
        if (priv.checked) {
          privs.push(priv.name)
        }
      })
      const privilegesMap = {}
      for (const p of privs) {
        privilegesMap[p] = true
      }
      this.user.privileges = privs
      this.user.privilegesMap = privilegesMap
      this.$emit('submit-user', this.user)
    },
    async disableUser () {
      const confirmed = await this.$confirm({
        type: 'is-danger',
        title: 'Disable User',
        message: `Are you sure you want to disable user <p class="bold">${this.user.firstName} ${this.user.lastName}</p>`
      })
      if (!confirmed) return
      this.$emit('disable-user', this.user)
    },
    updatePrivs () {

    }
  }
}
</script>
